/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Form as SemanticForm } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Input from './input';
import Segment from './segment';
import Tags from './tags';
import DatePicker from './date';
import Password from './password';
import isField from './isField';
import set from 'lodash/set';
import Validations from './validations';
import Checkbox from './checkbox';
import LabeledInput from './labeledInput';
import DomainInput from './domainInput';
import AppNameInput from './appnameInput';
import InfoLabel from '../infoLabel';
import CharCountInput from './charCountInput';
import TextArea from './textArea';
import Sharing from './sharing';
import IconSelector from './iconSelector';

/**
 * A component that allows to implement a form with sync state between the form and children.
 */
class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validations: undefined,
            form: {},
        };
    }

    static childContextTypes = {
        onFieldChange: PropTypes.func,
        validations: PropTypes.object,
    };

    /*Pass the validations object through context. Also the onFieldChange used by isField to update a form field*/
    getChildContext() {
        return {
            onFieldChange: this.onFieldChange,
            validations: this.state.validations,
        };
    }

    componentDidMount = () => {
        if (this.props.getValidationFunction) this.props.getValidationFunction(this.validate);
    };

    /*Just an optimization to reduce re-rendering while data is loading*/
    shouldComponentUpdate = (nextProps, nextState) => {
        if (this.props.loading === false) return true;
        if (this.props.loading === true && nextProps.loading === false) return true;
        if (this.state.validations !== nextState.validations) return true;
        return false;
    };

    onFieldChange = (e, { name, value }) => {
        const { form } = this.state;     
        set(form, name, value);
        this.setState({ form }, () => this.onChange(form));
    };

    /*The onSubmit form handler*/
    onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        const { schema } = this.props;
        let { form } = this.state;

        /*beforeSubmit is a hook to change the form before being validated*/
        if (this.props.beforeSubmit) form = this.props.beforeSubmit(form);

        let validations = false;
        if (schema && schema.validate) validations = schema.validate(form);

        this.validate(form, () => {
            if (this.props.onSubmit) {
                this.props.onSubmit(form, validations);
            }
        });
    };

    //Validate the form based on schema
    validate = (form, cb) => {
        const { schema } = this.props;
        if (!form) form = this.state.form;
        let validations = false;
        if (schema && schema.validate) validations = schema.validate(form);

        this.setState({ validations }, () => {
            if (cb) cb(form, validations);
        });
    };

    onChange = () => {
        if (this.props.onChange) this.props.onChange(this.state.form);
    };

    render() {
        const { schema, children, onSubmit, onChange, beforeSubmit, loading, ...rest } = this.props;

        return (
            <SemanticForm {...rest} onSubmit={this.onSubmit} loading={loading}>
                {children}
            </SemanticForm>
        );
    }
}

Form.Segment = Segment;
Form.Button = SemanticForm.Button;
Form.Group = SemanticForm.Group;
Form.Field = SemanticForm.Field;
Form.Radio = isField(SemanticForm.Radio);
Form.Checkbox = isField(SemanticForm.Checkbox);
Form.Dropdown = isField(SemanticForm.Dropdown);
Form.Input = isField(Input);
Form.Dropdown = isField(SemanticForm.Dropdown);
Form.Select = isField(SemanticForm.Select);
Form.TextArea = isField(TextArea);
Form.Tags = isField(Tags);
Form.Password = isField(Password);
Form.DatePicker = isField(DatePicker);
Form.Validations = Validations;
Form.Checkbox = isField(Checkbox);
Form.LabeledInput = isField(LabeledInput);
Form.DomainInput = isField(DomainInput);
Form.AppNameInput = isField(AppNameInput);
Form.InfoLabel = InfoLabel;
Form.CharCountInput = isField(CharCountInput);
Form.Sharing = Sharing;
Form.IconSelector = isField(IconSelector);

export default Form;
